import { Match } from "../../components/handball";
import { nextPowerOfTwo, numericId, pickScore } from "./utils";

export function buildMatchesForTournament(tId: string, participantIds: string[]): Match[] {
  const matches: Match[] = [];
  let round = 1;
  let current = participantIds.slice();
  const totalSlots = nextPowerOfTwo(current.length);
  current = current.concat(Array(totalSlots - current.length).fill(undefined as unknown as string));

  let roundSeeds = current.slice();
  while (roundSeeds.length > 1) {
    const winners: string[] = [];
    for (let i = 0; i < roundSeeds.length; i += 2) {
      const a = roundSeeds[i];
      const b = roundSeeds[i + 1];
      if (!a && !b) continue;
      if (a && !b) { winners.push(a); continue; }
      if (!a && b) { winners.push(b); continue; }
      const id = `${tId}-r${round}-m${(i / 2) + 1}`;
      const aWins = numericId(a) <= numericId(b);
      const winnerId = aWins ? a : b;
      matches.push({ id, tournamentId: tId, round, player1Id: a, player2Id: b, winnerId, score: pickScore(i + round) });
      winners.push(winnerId);
    }
    round += 1;
    roundSeeds = winners;
  }
  return matches;
}


